import PriceRangeController from './price-range-controller';
import template from './price-range.html';

export default function PriceRange() {
    return {
        restrict: 'A',
        scope: {
            minimum: '=',
            maximum: '=',
            rangeValues: '=ngModel',
        },
        bindToController: true,
        controller: PriceRangeController,
        controllerAs: 'priceRangeCtrl',
        template,
        link: {
            pre: preLink,
        },
    };

    function preLink($scope, $elem, $attrs, priceRangeCtrl) {
        priceRangeCtrl.$onInit();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/price-range/price-range-directive.js